import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import ChevronWhite from '../../images/chevronBoldWhite.svg';
import Chevron from '../../images/chevronLightBlack.svg';
import { colors } from '../../styles/constants';
import { Icon12 } from '../Icon';

const Container = styled.div`
  ${tw`w-full flex justify-between pb-abs1 cursor-pointer items-baseline md:items-center`};
  border-bottom: 1px solid
    ${(props) => (props.white ? 'rgba(255, 255, 255, 0.3)' : colors.grey200)};
`;

const Icon = styled.img`
  ${Icon12}
  transform: rotate(${(props) => (props.detailed ? '180deg' : '0')});
  transition: transform 200ms ease-out;
`;

const Header = ({ detailed, header, id, toggle, white }) => (
  <Container id={`header${id}`} onClick={() => toggle()} white={white}>
    {header}
    <Icon
      alt="En savoir plus"
      detailed={detailed}
      src={white ? ChevronWhite : Chevron}
    />
  </Container>
);

Header.propTypes = {
  detailed: PropTypes.bool,
  header: PropTypes.node,
  id: PropTypes.string,
  toggle: PropTypes.func,
  white: PropTypes.bool,
};

export default Header;
